
import React from 'react';

class TabContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      current: props.tabs[0].id,
    }
  }

  onClick = id => ev => {
    this.setState({current: id});
  };

  render = () => {

    const tab_style = {
      overflow: "hidden",
      borderTop: "1px solid #ccc",
      borderLeft: "1px solid #ccc",
      borderRight: "1px solid #ccc",
      backgroundColor: "#f1f1f1",
    }
    const button_style = {
      backgroundColor: "inherit",
      float: "left",
      border: "none",
      outline: "none",
      cursor: "pointer",
      padding: "14px 16px",
      transition: "0.3s",
    };

    const tabs = this.props.tabs;

    const current_button = tabs.find(button => this.props.current === button.id);
    const container_style = {
      padding: "6px 12px",
      border: "1px solid #ccc",
      borderTop: "none",
    };

    const onClick = button_id => ev => {
      this.props.onClick(button_id);
    };

    return (
      <div style={this.props.tabContainerStyle}>
        <div style={tab_style}>
          { tabs.map(button => {
            const style = { ...button_style};
            if (this.props.current === button.id) {
              delete style.backgroundColor;
              style.backgroundColor = "#fff";
            }
            return (
              <button
                key={button.id}
                style={style}
                onClick={onClick(button.id)}>
                { button.label }
              </button>
            )
          })}
        </div>
        <div style={container_style}>
          { current_button && current_button.content }
        </div>
      </div>
      );

  }
}

export { TabContainer };
